import type { User } from '@supabase/supabase-js';
import type { SpaceMembership } from '../../../contexts/SpaceContext';
import type { ConsultationRole } from '../types';

/** Stored in the user's auth metadata, so the onboarding is seen once across devices. */
export const ONBOARDING_COMPLETED_KEY = 'consultation_onboarding_completed_at';

type Params = {
  user: User | null;
  role: SpaceMembership['role'] | undefined;
  isSuperAdmin: boolean;
};

/** Only members who consult the space (readers, council members) get it; admins manage the space. */
export function getConsultationRole(
  role: SpaceMembership['role'] | undefined,
  isSuperAdmin: boolean,
): ConsultationRole | null {
  return !isSuperAdmin && (role === 'reader' || role === 'board_member') ? role : null;
}

export function shouldShowOnboarding(params: Params) {
  if (!params.user || !getConsultationRole(params.role, params.isSuperAdmin)) {
    return false;
  }
  return !params.user.user_metadata?.[ONBOARDING_COMPLETED_KEY];
}
